import {
  FETCH_VES_ELIGIBILITY_ERROR,
  FETCH_VES_ELIGIBILITY_PENDING,
  FETCH_VES_ELIGIBILITY_SUCCESS,
  FETCH_VES_ELIGIBILITY_THROTTLED,
  RESET_VES_ELIGIBILITY,
} from '../actions/types';

const initialState = {
  loading: false,
  error: null,
  data: null,
  throttled: false,
};

export default function vesEligibilityReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_VES_ELIGIBILITY_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
        throttled: false,
      };
    case FETCH_VES_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        throttled: false,
        data: action.data,
      };
    case FETCH_VES_ELIGIBILITY_THROTTLED:
      // Preserve existing data — do not clear last known status
      return {
        ...state,
        loading: false,
        error: null,
        throttled: true,
      };
    case FETCH_VES_ELIGIBILITY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case RESET_VES_ELIGIBILITY:
      return { ...initialState };
    default:
      return state;
  }
}
